<template>
  <div :class="b({ small: list.length > 3, medium: list.length === 3 })">
    <div :class="b('main')">
      <div
        v-for="item of list"
        :key="item.id"
        :class="b('item', { favorite: favorite ? item.favorite : false })"
      >
        <div
          :class="b('image-box')"
          @click="playVideo(item)"
        >
          <img
            :src="item.extend.videoImg"
            alt=""
          >
          <div :class="b('play-button')">
            <div :class="b('mask')"></div>
            <div :class="b('content')">
              <em class="zkicon iconbofanganniu"></em>{{ item.extend.videoSecond }}{{ $t('guide.scene.play') }}
            </div>
          </div>
        </div>
        <section>
          <div :class="b('head')">
            {{ item.head }}
          </div>
          <div
            :class="b('desc')"
            v-html="item.description"
          ></div>
          <div :class="b('action')">
            <el-link
              v-if="item.documentUrl"
              type="primary"
              :class="[
                b('document', { 'is-visited': item.isVisided }),
                b('view')
              ]"
              :underline="false"
              @click="openDoc(item)"
            >
              <em class="zkicon iconchakanwendang"></em>
              <span :class="b('document-text')">{{
                $t('highlights.viewDocument')
              }}</span>
            </el-link>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { isWebUrl } from '@zk/framework-vue';
import { openVideoDialog } from '../video';
// import { createUserInitIssue } from 'common-module/src/api/user';
// let hasCreateIssue = false;
export default {
  name: 'GuideScene',
  bemNS: theme.bemNS,
  props: {
    list: {
      type: Array,
      default: () => []
    },
    favorite: {
      type: Boolean,
      default: true
    },
    from: {
      type: String,
      default: 'loginPage'
    }
  },
  data() {
    return {};
  },
  computed: {
    shouldTrack() {
      return this.from === 'loginPage';
    }
  },
  methods: {
    // beforeAction(item){
    //   if (item.code === 'BUG_DASHBOARD') {
    //     this.createBugIssue();
    //   }
    // },
    // createBugIssue(){
    //   if (hasCreateIssue) {
    //     return;
    //   }
    //   hasCreateIssue = true;
    //   try {
    //     createUserInitIssue('bug');
    //   } catch (err) {
    //     hasCreateIssue = false;
    //   }

    // },
    openDoc(item) {
      item.favorite = true;
      // this.beforeAction(item);
      this.$emit('viewDoc', item);
      this.$nextTick(() => {
        this.shouldTrack &&
          this.$track.send(
            'UG_ClickScene',
            {
              ab_model: '平铺',
              location: '文档',
              scene_name: item.head
            },
            true
          );
      });
      if (isWebUrl(item.documentUrl)) {
        window.open(item.documentUrl);
        return;
      }
      window.open(
        this.$config.getDocUrl(item.documentUrl)
      );
    },
    playVideo(item) {
      item.favorite = true;
      openVideoDialog({
        url: item.videoUrl,
        onClose: (state) => {
          this.$track.send(
            'UserGuide_Video',
            { complete: state.ended, EndPlayTime: state.currentTime },
            true
          );
          if (this.shouldTrack) {
            this.$track.send(
              'UG_CloseVideo',
              {
                complete: state.ended,
                scene_name: item?.head,
                EndPlayTime: state.currentTime
              },
              true
            );
          }
        }
      });
      // this.$refs.introduceVideoRef?.openVideo(item);
      this.$emit('playVideo', item);
      this.shouldTrack &&
        this.$track.send(
          'UG_ClickScene',
          {
            ab_model: '平铺',
            location: '视频',
            scene_name: item.head
          },
          true
        );
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(guide-scene) {
  margin: auto;
  @include e(main) {
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    flex-wrap: wrap;
    margin-left: -40px;
  }
  @include e(item) {
    display: flex;
    flex-direction: column;
    width: 370px;
    margin-left: 40px;
    margin-bottom: 24px;
    border: 1px solid var(--color-border-2);
    box-shadow: var(--shadow-normal);
    border-radius: 8px;
    // &:first-child{
    //   margin-left: 0 !important;
    // }
    font-size: 0;
    @include m(favorite) {
      @include e(head) {
        color: rgba(121, 122, 133, 1);
      }
      @include e(desc) {
        color: rgba(165, 166, 174, 1);
      }
    }
    @include e(image-box) {
      overflow: hidden;
      position: relative;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      width: 100%;
      height: 208px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      @include e(play-button) {
        position: absolute;
        left: 20px;
        bottom: 10px;
        width: 82px;
        height: 36px;
        cursor: pointer;
        border-radius: 219px;
        color: #fff;
        font-size: 14px;
        @include e(content) {
          height: 36px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 1;
          .zkicon {
            color: #fff;
            margin-right: 4px;
          }
        }
        @include e(mask) {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #000;
          opacity: 0.4;
          border-radius: 219px;
        }
      }
      &:hover {
        @include e(play-button) {
          @include e(mask) {
            opacity: 0.6;
          }
        }
        cursor: pointer;
        img {
          transform: scale(1.03);
        }
      }
    }
    section {
      flex: 1;
      padding: 20px;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      @include e(head) {
        font-size: 16px;
        font-weight: var(--weight-font-Semiblod);
        color: var(--font-color-1);
        margin-bottom: 6px;
        line-height: 1;
      }
      @include e(desc) {
        font-size: 14px;
        line-height: 20px;
        color: var(--font-color-2);
        margin-bottom: 20px;
        flex: 1;
      }
      @include e(action) {
        height: 60px;
        display: flex;
        font-size: 14px;
        align-items: center;
        border-top: 1px solid var(--color-border-2);
        ::v-deep {
          .el-divider--vertical {
            margin: 0 12px;
          }
        }
      }
      @include e(document) {
        cursor: pointer;
        @include e(document-text) {
          margin-left: 2px !important;
        }
        .zkicon {
          position: relative;
          top: 1px;
          font-size: 18px;
        }
        span {
          position: relative;
          &:hover {
            &::after {
              position: absolute;
              bottom: -1px;
              height: 1px;
              left: 0;
              right: 0;
              content: ' ';
              background: var(--link-primary-color);
            }
          }
        }
        @include m(is-visited) {
          opacity: 0.6;
        }
      }
    }
  }
  @include m(medium) {
    width: 1060px;
    @include e(main) {
      margin-left: -32px;
    }
    @include e(item) {
      width: 312px;
      margin-left: 32px;
      @include e(image-box) {
        height: 175px;
      }
    }
  }
  @include m(small) {
    @include e(main) {
      margin-left: -24px;
      justify-content: left;
      width: 1184px;
    }
    @include e(item) {
      width: 272px;
      margin-left: 24px;
      @include e(image-box) {
        height: 153px;
      }
    }
  }
}
</style>
